import React from 'react';
import { Link } from 'react-router-dom';
import '../Login/login.css'

function LoginForm() {
    return (
        <div className='card'>
             <div className="container">
            <h2>Login</h2>
            <form>
                <input type="text" placeholder="E-mail" required />
                <input type="password" placeholder="Password" required />
                <div className="remember-me">
                    <label>
                        <input type="checkbox" /> Remember me
                    </label>
                </div>
                <button type="submit">Log in</button>
            </form>

            <section className="footer">
                {/* <Link to="/forgotpass">Forgot Password? </Link> */}
                <p>Don't have an account?</p>
                <Link to="/signup">Sign Up</Link>
            </section>
        </div>
        </div>
       
    );
}

export default LoginForm;
